// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I19XRUxVHZIeVr6OCDFp {
  padding: 5px 10px;
  cursor: pointer;
}
.ViU_CpqjZo2YXk_XiH3k {
  color: #fff;
  background-color: #037C4B;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Header/Simulation/Workbook/SeqActionRow/styles.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,eAAA;AACF;AAEA;EACE,WAAA;EACA,yBAAA;AAAF","sourcesContent":[".actionItem {\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.active {\n  color: #fff;\n  background-color: #037C4B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionItem": `I19XRUxVHZIeVr6OCDFp`,
	"active": `ViU_CpqjZo2YXk_XiH3k`
};
export default ___CSS_LOADER_EXPORT___;
